<template>
  <div class="auth-config dialog-body scrollable">
    <el-table
      ref="dataPermissionTable"
      :data="dataPermissionData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="agentName" label="合作机构"> </el-table-column>
    </el-table>
    <div class="diloag-footer">
      <el-button @click="onCancle">取消</el-button>
      <el-button type="primary" @click="onSave">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getDataPermissionList, updateDataPermission } from "@/api/agentUser";

export default {
  name: "AgentUserDataPermission",
  props: {
    userId: {
      type: String,
      required: true
    },
    agentId: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      dataPermissionLoading: false,
      dataPermissionData: [],
      agentIds: []
    };
  },
  watch: {
    userId: {
      handler: function() {
        this.loadDataPermission();
      },
      deep: true
    }
  },
  mounted: function() {
    //加载tree
    this.loadDataPermission(true);
  },
  methods: {
    handleSelectionChange(val) {
      let that = this;
      that.agentIds = val.map(item => {
        return item.agentId;
      });
      if (that.agentIds.indexOf(that.agentId) < 0) {
        that.$message({
          message: "用户所属机构必须选中",
          type: "error"
        });
        that.dataPermissionData.forEach((item, i) => {
          if (item.agentId === that.agentId) {
            that.$refs.dataPermissionTable.toggleRowSelection(
              that.dataPermissionData[i]
            );
          }
        });
      }
    },
    loadDataPermission: function() {
      let that = this;
      that.dataPermissionLoading = true;
      getDataPermissionList(this.userId)
        .then(res => {
          if (res.code === "200") {
            that.dataPermissionData = res.data.agentList;
            that.$nextTick(() => {
              that.agentIds = res.data.dataPermissionList;
              res.data.dataPermissionList.forEach(item1 => {
                res.data.agentList.forEach((item2, i) => {
                  if (item2.agentId === item1) {
                    that.$refs.dataPermissionTable.toggleRowSelection(
                      that.dataPermissionData[i]
                    );
                  }
                });
              });
            });
          }
        })
        .finally(() => {
          that.dataPermissionLoading = false;
        });
    },
    onCancle: function() {
      this.$emit("on-cancel");
    },
    onSave: function() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      updateDataPermission(that.userId, that.agentIds)
        .then(res => {
          if (res.code === "200") {
            that.$message({
              message: "保存成功！",
              type: "success"
            });
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.$emit("on-cancel");
        });
    }
  }
};
</script>

<style>
.diloag-footer {
  padding-top: 10px;
  text-align: right;
  box-sizing: border-box;
  position: absolute;
  bottom: 10px;
  right: 24px;
}

.dialog-body {
  height: 500px;
  margin-bottom: 40px;
}
</style>
